import Exclamation from './exclamation';

export * from './exclamation';
export default Exclamation;
